import ComponentHeader from 'components/admin/Helper/ComponentHeader'
import ComponentPlaceholder from 'components/admin/Helper/ComponentPlaceholder'
import Tabs from 'components/admin/Helper/Tabs'
import AddressList from 'components/shared/Addresses/AddressList'
import config from 'config/config'
import { I18n } from 'lib/i18n'
import { classNames } from 'lib/utilities'
import React from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { bindActionCreators } from 'redux'
import { formValues, reduxForm, registerField } from 'redux-form'
import { confirmationModal, setDirtyFormState } from 'redux/navigation'
import { deleteUser, saveUser } from 'redux/userAdmin'
import { Button, Segment } from 'semantic-ui-react'
import UserCoreData from './UserCoreData'
import UserMedia from './UserMedia'
import BOP from './BOP'

const i18nkey = 'admin.user.tabs.'

const mapStateToProps = (state, ownProps) => {
  const { userSaving, users = [] } = state.userAdmin
  const { currentUser } = state.user
  return { userSaving, currentUser, users }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      registerField,
      saveUser,
      deleteUser,
      push,
      setDirtyFormState,
      confirmationModal,
    },
    dispatch
  )

class UserDetails extends React.Component {
  constructor(props) {
    super(props)
    this.changeAddress = this.changeAddress.bind(this)
  }

  componentWillMount() {
    const { user = {}, change } = this.props
    if (user.wd_deleted) {
      change('status', 'archived')
    }
  }

  componentWillReceiveProps(nextProps) {
    const { userSaving: oldUserSaving } = this.props
    const {
      userSaving: newUserSaving,
      user = {},
      change,
      push,
      form,
    } = nextProps

    if (
      oldUserSaving === true &&
      newUserSaving === false &&
      form === 'dealer_import_form'
    ) {
      push(config.nodes.dashboard)
    }

    if (user.wd_deleted) {
      change('status', 'archived')
    }
  }

  componentDidUpdate(prevProps) {
    const { setDirtyFormState } = this.props
    if (prevProps.dirty !== this.props.dirty)
      setDirtyFormState(this.props.dirty)
  }

  changeAddress(address) {
    const { change, array } = this.props
    if (address.index !== undefined)
      change(`addresses[${address.index}`, address)
    else array.push('addresses', address)
  }

  getTabs() {
    const {
      user = {}, //ownProps
      form,
      array,
      change, //reduxForm
    } = this.props
    const isWinDeltaDealer =
      user.user_type === 'dealer' ||
      user.user_type === 'bop' ||
      user.user_type === 'shop' ||
      form === 'dealer_import_form'
    const tabs = [
      'core',
      'media',
      'addresses',
      ...(user.user_type === 'bop' ? ['bop'] : []),
    ]
    const definedTabs = {
      core: {
        title: I18n.t(i18nkey + 'core'),
        key: 'core',
        content: (
          <UserCoreData {...{ user: user, change, isWinDeltaDealer }} />
        ),
      },
      media: {
        title: I18n.t(i18nkey + 'media'),
        key: 'media',
        content: <UserMedia {...{ form, registerField, array }} />,
      },
      addresses: {
        title: I18n.t(i18nkey + 'addresses'),
        key: 'addresses',
        content: (
          <AddressList
            {...{
              changeAddress: this.changeAddress,
            }}
          />
        ),
      },
      bop: {
        title: I18n.t(i18nkey + 'bop'),
        key: 'bop',
        content: <BOP {...{ change }}/>,
      },
    }
    return tabs.map((tab) => definedTabs[tab])
  }

  render() {
    const dark = config.theme.dark
    const {
      user = {}, //ownProps
      saveUser,
      confirmationModal,
      push,
      users, //connect
      initialized,
      invalid,
      form,
      handleSubmit,
      reset,
      dirty,
      email, //reduxForm
    } = this.props
    let title
    if (user.wd_deleted) title = I18n.t('admin.user.title.attention_deleted')
    else if (form === 'dealer_import_form')
      title = I18n.t('admin.user.title.import')
    else if (!user.user_type) title = I18n.t('admin.user.title.new_user')
    // title = `${I18n.t(`admin.user.title.${user.user_type}`)} ${user.kind && ` - ${user.kind}`}`
    else
      title = user.kind
        ? user.kind
        : I18n.t(`admin.user.title.${user.user_type}`)

    return !initialized ? (
      <div className="inactive-window">
        <ComponentPlaceholder loading={false} />
      </div>
    ) : (
      <div
        className={classNames([
          'DealerDetails',
          'form',
          'ui',
          dark && 'inverted',
        ])}>
        <ComponentHeader
          {...{
            dirty,
            title,
            customActions: [
              <Button
                disabled={user.id && !dirty}
                labelPosition="right"
                content={I18n.t('global.cancel')}
                icon="cancel"
                secondary
                onClick={() => {
                  let confirm = () =>
                    console.error('confirm action not defined')
                  if (form === 'dealer_import_form')
                    push(config.nodes.dashboard)
                  else if (user.id) {
                    confirm = () => reset()
                  } else {
                    confirm = () => push(config.nodes.user)
                  }
                  confirmationModal({
                    doNotDisplay: !dirty,
                    icon: config.icons.delete,
                    negative: true,
                    title: I18n.t('global.abortModal.title'),
                    text: I18n.t('global.abortModal.text'),
                    button: I18n.t('global.abortModal.button'),
                    confirm,
                  })
                }}
              />,
              <Button
                {...{
                  content:
                    form === 'dealer_import_form'
                      ? I18n.t('admin.user.action_import')
                      : I18n.t('admin.user.action'),
                  labelPosition: 'right',
                  icon: 'checkmark',
                  color: 'green',
                  disabled:
                    invalid ||
                    (user.id && !dirty) ||
                    (form === 'dealer_import_form' &&
                      !!users.find((user) => user.email === email)),
                  onClick: handleSubmit((formValues) => {
                    saveUser({ ...formValues })
                  }),
                }}
              />,
            ],
          }}
          /* TODO: Add type to title */
        />

        <Segment
          attached
          className={classNames(['payload', 'small', dark && 'inverted'])}>
          <Tabs
            tabs={this.getTabs()}
            startTab="core"
            context="dealer_details"
          />
        </Segment>
      </div>
    )
  }
}

UserDetails = connect(mapStateToProps, mapDispatchToProps)(UserDetails)
UserDetails = formValues('email')(UserDetails)
UserDetails = reduxForm()(UserDetails)
export default UserDetails



// WEBPACK FOOTER //
// ./src/components/admin/Users/UserDetails.jsx